import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { SortDirection } from '../../../../../../../enums/sortDirection'

export interface SortValue<T> {
  sortProperty: T
  sortDirection: SortDirection
}

interface GetDrawerListSortOptionsProps<T> {
  amountProperty: T
  dateProperty: T
  t: TFunction
}

export const getDrawerListSortOptions = <T extends string>({
  amountProperty,
  dateProperty,
  t,
}: GetDrawerListSortOptionsProps<T>): NavItem<SortValue<T>>[] => [
  {
    id: `${amountProperty}_${SortDirection.Desc}`,
    children: t('bank_transactions.drawer.sort_amount_desc'),
    value: { sortProperty: amountProperty, sortDirection: SortDirection.Desc },
  },
  {
    id: `${amountProperty}_${SortDirection.Asc}`,
    children: t('bank_transactions.drawer.sort_amount_asc'),
    value: { sortProperty: amountProperty, sortDirection: SortDirection.Asc },
  },
  {
    id: `${dateProperty}_${SortDirection.Desc}`,
    children: t('bank_transactions.drawer.sort_date_desc'),
    value: { sortProperty: dateProperty, sortDirection: SortDirection.Desc },
  },
  {
    id: `${dateProperty}_${SortDirection.Asc}`,
    children: t('bank_transactions.drawer.sort_date_asc'),
    value: { sortProperty: dateProperty, sortDirection: SortDirection.Asc },
  },
]
